module.exports = __webpack_public_path__ + "img/bg_page_bottom.39f1c7f1.png";